import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';


@Injectable({
    providedIn: 'root'
})
export class ErrorService {

    constructor() {

    }

    handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            const message = error.error ? error.error : this.sanitizeMessage(error.message);
            console.error('Error: ', message);
            // this.appDialogService.showMessageDialog(operation + ' failed', message);
            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    handleErrors(errors: Array<HttpErrorResponse>): boolean {
        const messages: Array<string> = new Array<string>();
        let isANonNull = false;
        errors.forEach(error => {
            if (error && error.error) {
                console.error('Error: ', error.error);
                messages[messages.length] = error.message ? error.message : error.error;
                isANonNull = true;
            }
        });

        if (isANonNull) {
            alert('Errors' + messages);
        }

        return isANonNull;
    }

    public sanitizeMessage(message: string): string {
        if (message) {
            const httpIdx = message.indexOf('http');
            const restIdx = message.indexOf('/rest/');

            if (httpIdx > -1 && restIdx > -1) {
                message = message.substring(0, httpIdx) + ' ' + message.substring(restIdx + 6).replace(/\//g, ' ');
            }
        }

        return message;
    }
}
